import React from "react";
import moment from "moment";

export const Timesheet_Variables = {
	taskType: [
		{ value: 0, label: "org" },
		{ value: 1, label: "pro" },
		{ value: 2, label: "pre" },
		{ value: 3, label: "per" },
	],
	TimesheetConfirm: "Are you sure?",
	TimesheetAcceptConfirm: "Are you sure you want to accept?",
	TimesheetRejectConfirm: "Are you sure you want to reject?",
	acceptTimesheetMsg: "Timesheet accepted",

	rejectTimesheetMsg: "Timesheet rejected",
	react_select_style: {
		control: (base) => ({
			...base,
			borderRadius: "10px",
			width: "100%",
			backgroundColor: "#F5F5F5",
			boxShadow: null,
			borderColor: "#CFCFCF",
			fontSize: "14px",
			color: "#7ebfc0",
		}),
		indicatorSeparator: (base) => ({
			...base,
			display: "none",
		}),
		dropdownIndicator: (base) => ({
			...base,
			color: "#7ebfc0",
		}),
	},
	react_multiselect_style: {
		control: (base) => ({
			...base,
			borderRadius: "10px",
			outline: "0 !important",
			width: "100%",
			borderColor: null,
			boxShadow: null,
			border: "0",
			minHeight: "27px",
			height: "auto",
			fontSize: "12px",
			color: "#7ebfc0",
		}),
	},
};
//---------------------------------------
//Format Group Labels
const groupStyles = {
	display: "flex",
	alignItems: "center",
	textAlign: "center",
	justifyContent: "center",
	fontSize: 15,
	color: "#a1a1a1",
	fontWeight: "bold",
};
export const FormatGroupOptions = (data) => {
	return (
		<>
			<div style={groupStyles}>
				<span>
					------------------------------------------------------
					{data.label}
					------------------------------------------------------
				</span>
			</div>
		</>
	);
};
//-----------------------------------------
//Hours to minutes
export const hoursToMinutes = (time) => {
	let hms = time;
	let a = hms.split(":");
	let minutes = +a[0] * 60 + +a[1];

	return minutes;
};
//------------------------------------------
//Minutes to hours
export const minutesToHours = (time) => {
	let hours = Math.floor(time / 60);
	let minutes = time % 60;
	let sum = hours + ":" + minutes;
	let formatted = moment(sum, "hh:mm").format("HH:mm");
	if (hours <= 23) {
		return formatted;
	} else {
		return sum;
	}
};
//-----------------------------------------
//Format Date
export const formatDate = (date) => {
	let d = new Date(date),
		month = "" + (d.getMonth() + 1),
		day = "" + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) month = "0" + month;
	if (day.length < 2) day = "0" + day;
	let temp = [year, month, day].join("-");
	return temp;
};
//---------------------------------------
//JSON DATE
export const convertToJSONDate = (strDate) => {
	let event = new Date(strDate);
	return event.toJSON();
};
//---------------------------------------
// Default Hours
export const defaultHours = [
	"00:00",
	"00:00",
	"00:00",
	"00:00",
	"00:00",
	"00:00",
	"00:00",
];
